import { InjectionKey, Ref } from 'vue';
import { SupplierBrandViewService } from '../brand-view.service';

export const brandServiceKey = Symbol() as InjectionKey<Ref<SupplierBrandViewService>>;
